
const logisticaModulo = {
    agGrid: {
        pagination  : true,
        pagina      : 15,
        id          : 'myGrid',
        //class       : 'ag-theme-alpine',
        class       : 'ag-theme-balham',
        rowHeight   : 35,
        style: {
            width: '100%',
            height: '700px',
            'font-size': 'smaller',
        }
    },
    agGridModal: {
        paginacion: 10,
        id: 'myGrid',
        class: 'ag-theme-material mt-3',
        style: {
            width: '100%',
            height: '450px'
        }
    },
    titulos: {
        global: {
          modulo          : 'Logistica',
          tituloAgregar   : 'Agregar Nuevo Registro',
          tituloActualizar: 'Actualizar Registro',
          tituloEliminar  : 'Eliminar Registro',
        },
        documentos: {
          titulo        : 'Registro de Documentos',
          tituloCardList  : 'Viajes',
        },
        convoy: {
          titulo        : 'Crear Convoys',
          tituloCardList  : 'Convoys Preparados',
        },
        planificacion: {
          titulo        : 'Registro de Planificacion de Viajes',
          tituloCardList  : 'Listado de Viajes',
                  },
        garita: {
          titulo        : 'Registro de Check Garita',
          tituloCardList  : 'Listado de Viajes',
        },
        vehicular: {
          titulo        : 'Registro de Check Vehicular',
          tituloCardList  : 'Listado de Viajes',
        },
        balanza: {
          titulo        : 'Completar Viaje - Balanza',
          tituloCardList  : 'Listado de Viajes',
        },
        garitaAprobar: {
          titulo        : 'Registro de Check Garita - Aprobar',
          tituloCardList  : 'Listado de Viajes',
        },
        supervisor: {
          titulo        : 'Registro de Andenes',
          tituloCardList  : 'Viajes',
        },
        tipos: {
          titulo        : 'Registro de Tipos de Planificación',
          tituloCardList  : 'Listado de Tipos',
        },
        areas: {
          titulo        : 'Registro de Areas Logisticas',
          tituloCardList  : 'Listado de Areas',
        },
        bitacora: {
          titulo          : 'Bitacora de Movimientos de Viajes',
          tituloCardList  : 'Lista de movimientos',
        },
        marquesina: {
          titulo          : 'Configuracion de Marquesina',
          tituloCardList  : 'Marquesinas',
        },
        marquesina_mensajes: {
          titulo          : 'Configuracion de Mensajes de marquesina',
          tituloCardList  : 'Mensajes',
        },
        configuracion_general: {
          titulo          : 'Configuración General de Logística',
          tituloCardList  : 'Listado de Parámetros',
        },
        checkGaritaSalida: {
          titulo        : 'Registro de Check Garita Salida',
          tituloCardList  : 'Convoys Preparados',
        },
        depuracionPedidos: {
          titulo          : 'Historial de Depuración de Pedidos',
          tituloCardList  : 'Gestión Incidencias Logística y Matriz de Consecuencias',
        },
    },
    url: {
        planificacion   : 'tracking-viaje',
        tipo_viajes     : 'tipo-viaje',   
        check_vehicular : 'tracking-check-vehicular',   
        check_garita    : 'tracking-check-garita',
        viaje_anden     : 'tracking-viaje-anden',
        actividades     : 'tracking-actividades',
        viaje_carga     : 'tracking-viaje-carga',
        viaje_documentos: 'tracking-documentos',
        viaje_convoy    : 'tracking-convoy',   
        areas           : 'tracking-area-planta',
        bitacora        : 'tracking-bitacora',
        catalogos       : 'tracking-catalogos',
        preguntas       : 'tracking-checklist-maestro',
        respuestas      : 'tracking-checklist-respuesta',
        marquesinas     : 'marquesina',
        MarquesinaMsj   : 'marquesina-mensajes',
        parametros      : 'parametros-logistica',
        depuracion      : 'depuracion',
    },
    button: {
        buttonsCss: {
            primary   : 'btn btn-primary btn-block',
            secondary : 'btn btn-secondary btn-block',
            success   : 'btn btn-success btn-block',
            danger    : 'btn btn-danger btn-block',
            warning   : 'btn btn-warning btn-block',
            info      : 'btn btn-info btn-block',
            light     : 'btn btn-light btn-block',
            dark      : 'btn btn-dark btn-block',
            primaryOutline   : 'btn btn-outline-primary',
            secondaryOutline : 'btn btn-outline-secondary',
            successOutline   : 'btn btn-outline-success',
            dangerOutline    : 'btn btn-outline-danger',
            warningOutline   : 'btn btn-outline-warning',
            infoOutline     : 'btn btn-outline-info',
            lightOutline    : 'btn btn-outline-light',
            darkOutline     : 'btn btn-outline-dark',
            primarylg     : 'btn btn-primary btn-lg btn-block',
            successLg     : 'btn btn-success btn-lg btn-block',
            dangerLg      : 'btn btn-danger btn-lg btn-block',
            warningLg     : 'btn btn-warning btn-lg btn-block',
            warningLgFile : 'btn btn-warning btn-lg btn-block btn-file',
        },
        buttonsNombre: {
            editar: 'Editar',
            ver: 'Ver',
            eliminar: 'Eliminar',
            agregar: 'Agregar ',
            guardar: 'Guardar',
            actualizar: 'Actualizar',
            mostrar: 'Mostrar seleccion',
            regresar: 'Regresar',
            continuar: 'Continuar',
            seleccionar: 'Seleccionar',
            procesar: 'Procesar',
            buscar: 'Buscar',
            sustento: 'Sustento',
            validar: 'Validar',
            descargar: 'Descargar',
            descargarRecibo: 'Descargar Recibo Cobros',
            descargarEstado: 'Descargar Estados Docs',
            detalle: 'Ver Ordenes',
            agregarProducto: 'AÃ±adir Productos',
            anadirProducto: 'AÃ±adir',
            limpiar: 'Eliminar todos los productos',
            anular: 'Anular',
            aprobar: 'Aprobar',
        }
    },
    mensajes: {
        errorServicio: 'error..!!',
        desabilitada: 'Opción desabilitada',
        eliminar: '¿Está seguro de que desea eliminar el siguiente elemento?',
        guardar: '¿Está seguro de que desea guardar?',
        actualizar: '¿Está seguro de que desea actualizar el siguiente elemento?',
        datoGuardado: 'Se guardo corectamente..!!',
        guardarParada: 'Esta seguro que desea registrar este evento..??',
        procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
        validar: '¿Esta seguro que desea validar el siguiente elemento?',
        anticipo: 'Se tomara este valor como anticipo.',
        camposObligatorio: 'Los campos tipo transaccion y nÃºmero documento deben estar llenos caso contrario se tomara como anticipo.',
        anular: 'Confirma que desea eliminar el registro seleccionado.',
        garitaAprobar   : '¿Esta seguro que desea Aprobar la revisión del viaje?',
        garitaFinalizar : '¿Esta seguro que desea Finalizar el viaje?'
    },

  rutas: {
    OPERADOR: 'operador',
    SELLOS  : 'sellos',
  },
  /** SERVICES PARA EQUIPOS DE BASCULA */
  urlOnlyIntegracion: {
      /*coneccion     : 'Bascula/EstadoConexionBaseDatos',
      sentido       : 'Bascula/SetSentidoBascula',   
      marquesina    : 'Bascula/SetMensajeMarquesina',   
      statusBascula : 'Bascula/GetConsultaBascula',
      respuesta     : 'Bascula/respuesta'*/
      coneccion     : 'bascula-only/estado-conexion',
      sentido       : 'bascula-only/sentido-bascula',   
      marquesina    : 'bascula-only/mensaje-marquesina',   
      statusBascula : 'bascula-only/consulta-bascula',
  },
}

export type LogisticaDiccionario = typeof logisticaModulo;
export { logisticaModulo }